import React from "react";
import { Search, X } from "lucide-react";
import { useLang } from "../../context/LanguageContext";
import { localName } from "../../lib/directory";

const Select = ({ id, value, onChange, label, options }) => (
  <label className="flex flex-col gap-1 min-w-0">
    <span className="text-[11px] uppercase tracking-[0.15em] text-white/40">{label}</span>
    <select data-testid={id} value={value} onChange={(e) => onChange(e.target.value)}
      className="bg-ink border border-white/10 rounded-xl px-3 py-2.5 text-sm text-white outline-none focus:border-gold/50 transition-colors duration-200">
      {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  </label>
);

export const FilterBar = ({ filters, setFilter, query, setQuery, categories, neighborhoods, cuisines, onClear }) => {
  const { t, lang } = useLang();
  const any = filters.category || filters.neighborhood || filters.cuisine || query;
  const opt = (rows, allLabel, nameOf) => [{ value: "", label: allLabel }, ...rows.map((r) => ({ value: r.slug, label: `${nameOf(r)} (${r.count})` }))];
  return (
    <div className="glass rounded-2xl p-4 grid gap-3 md:grid-cols-12 items-end" data-testid="directory-filter-bar">
      <label className="md:col-span-4 flex flex-col gap-1">
        <span className="text-[11px] uppercase tracking-[0.15em] text-white/40">{t("directory.search")}</span>
        <div className="flex items-center gap-2 bg-ink border border-white/10 rounded-xl px-3 focus-within:border-gold/50 transition-colors duration-200">
          <Search size={15} className="text-white/40 shrink-0" />
          <input data-testid="directory-search-input" value={query} onChange={(e) => setQuery(e.target.value)}
            placeholder={t("directory.search_ph")} className="flex-1 bg-transparent py-2.5 text-sm text-white placeholder:text-white/35 outline-none min-w-0" />
        </div>
      </label>
      <div className={`grid gap-3 ${cuisines ? "md:col-span-6 sm:grid-cols-3" : "md:col-span-6 sm:grid-cols-2"}`}>
        <Select id="directory-category-filter" label={t("directory.category")} value={filters.category} onChange={(v) => setFilter("category", v)}
          options={opt(categories.filter((c) => c.count > 0), t("directory.all_categories"), (c) => localName(c.name, lang))} />
        <Select id="directory-neighborhood-filter" label={t("directory.neighborhood")} value={filters.neighborhood} onChange={(v) => setFilter("neighborhood", v)}
          options={opt(neighborhoods, t("directory.all_neighborhoods"), (n) => n.name)} />
        {cuisines && (
          <Select id="directory-cuisine-filter" label={t("directory.cuisine")} value={filters.cuisine} onChange={(v) => setFilter("cuisine", v)}
            options={opt(cuisines, t("directory.all_cuisines"), (c) => c.name)} />
        )}
      </div>
      <div className="md:col-span-2">
        <button onClick={onClear} disabled={!any} data-testid="directory-clear-filters"
          className="w-full inline-flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-xl border border-white/10 text-sm text-white/70 hover:border-gold/40 disabled:opacity-30 transition-colors duration-200">
          <X size={14} /> {t("directory.clear")}
        </button>
      </div>
    </div>
  );
};
